module.exports = __webpack_public_path__ + "img/John_Julie_Nixon@1x.6cb94772.webp";